module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 5@2x.f93a511d.png";